import React from 'react';
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell, Legend } from 'recharts';
import { Box, Card, Typography } from '@mui/material';

const FarmTypeCountChart = ({ farmTypeData }) => {
    const COLORS = ['#F9AA33', '#82ca9d', '#8884d8', '#ff7300', '#ffbb28', '#d0ed57', '#90caf9', '#4caf50'];

    return (
        <Card
            sx={{
                backgroundColor: '#181F2A',
                color: '#fff',
                borderRadius: 1.5,
                p: { xs: 2, md: 3 },
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 2px 8px 0 rgba(0,0,0,0.20)',
                mb: { xs: 2, md: 2 },
                minHeight: { xs: 350, md: 400 }
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 500, fontSize: 15, mr: 2, whiteSpace: 'nowrap' }}>
                    Farm Types Distribution
                </Typography>
            </Box>
            <Typography sx={{ color: '#AAB4C8', fontWeight: 400, fontSize: 12, mb: 1, mt: -1 }}>
                Number of farms by type
            </Typography>
            <Box sx={{ width: '100%', flex: 1, minHeight: 320, mt: 1, height: 280 }}>
                <ResponsiveContainer width="100%" height={280}>
                    <PieChart>
                        <Legend
                            layout="horizontal"
                            verticalAlign="top"
                            align="center"
                            iconType="circle"
                            wrapperStyle={{ color: '#AAB4C8', fontSize: 11 }}
                        />
                        <Pie
                            data={farmTypeData}
                            dataKey="count"
                            nameKey="type"
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={100}
                            fill="#F9AA33"
                            paddingAngle={2}
                        >
                            {farmTypeData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip 
                            formatter={(value, name) => [`${value} farms`, name]}
                            contentStyle={{ 
                                backgroundColor: '#222C2F', 
                                color: '#fff', 
                                border: '1px solid #283144',
                                borderRadius: 4,
                                boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                                fontSize: 12,
                                fontWeight: 500
                            }}
                            labelStyle={{ color: '#fff' }}
                            itemStyle={{ color: '#fff' }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </Box>
        </Card>
    );
};

export default FarmTypeCountChart;
